import Alpine from "alpinejs";
import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

Alpine.data('HeroCarousel', () => ({
    imageSwiper: null,
    contentSwiper: null,
    init(){
        let imageSwiper = this.$el.querySelector('.heroCarousel');
        this.imageSwiper = new Swiper(imageSwiper, {
            modules: [EffectFade],
            effect: 'fade',
            breakpoints: {
                768: {
                    allowTouchMove: false
                }
            },
        });

        let contentSwiper = this.$el.querySelector('.heroContentCarousel');
        this.contentSwiper = new Swiper(contentSwiper, {
            modules: [Navigation, Pagination, Autoplay],
            navigation: {
                nextEl: this.$el.querySelector('.swiper-btn-next'),
                prevEl: this.$el.querySelector('.swiper-btn-prev'),
            },
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                bulletActiveClass: 'opacity-100',
                clickable: true,
                renderBullet: function(index, className){
                    return '<span class="w-2 h-2 opacity-30 block rounded-full bg-primary-dark ' + className + '"></span>';
                }
            },
            autoplay: {
                delay: 5000
            }
        })

        this.contentSwiper.on('slideChange', () => {
            this.imageSwiper.slideTo(this.contentSwiper.activeIndex)
        })

        this.imageSwiper.on('slideChange', () => this.updateSlideVideos())
        this.updateSlideVideos()
    },
    updateSlideVideos(){
        this.imageSwiper.slides.forEach((slide, index) => {
            const video = slide.querySelector('video[data-lazy-video]');

            if (!video) return;

            if (index === this.imageSwiper.activeIndex) {
                const source = video.querySelector('source[data-src]');

                if (source) {
                    source.src = source.dataset.src;
                    source.removeAttribute('data-src');
                    video.load();
                }

                video.play().catch(() => {});
            } else {
                video.pause();
            }
        });
    },
}));